import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useStringsContext } from '../../../contexts/strings';
import MessageViewerContainer from './message-viewer';
import SceneHeader from '../../common/scene/scene-header';
import ScenePage from '../../common/scene/scene-page';

function MessageViewer() {
  const { strings } = useStringsContext();
  return (
    <ScenePage title={strings.appBar.messageViewer} breadCrumps={[strings.appBar.superAdmin]}>
      <SceneHeader title={strings.appBar.messageViewer} />
      <Switch>
        <Route exact path="/message-viewer" component={MessageViewerContainer} />
      </Switch>
    </ScenePage>
  );
}

export default MessageViewer;
